import { render, staticRenderFns } from "./CharacteristicsManagement.vue?vue&type=template&id=0764e981&"
import script from "./CharacteristicsManagement.vue?vue&type=script&lang=js&"
export * from "./CharacteristicsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports